import React from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

const PsychlngclCheckMain: React.FC = () => {
    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className="contents">
                        <h2>무료심리검사</h2>
                        <Location locations={[{title: "토닥토닥마음케어", url: "/columnList"}]} menuName='무료심리검사'/>
                        <div className="mobileface testing">
                            <p className="green f18 lh24 mb30 bold">“심리 검사를 통해 내 안의 나를 확인하고, 결과 별 심리 케어 방법을 찾아보세요."</p>
                            <div className="testingItem mt30">
                                <ul>
                                    <li className="bg1">
                                        <a href="/psychlgclCheck/stress">
                                            <img src="/images/therapy/therapy_stress.png" alt=""></img>
                                            <strong className="f18">스트레스 자가진단</strong>
                                            <span>(5문항)</span>
                                            <span className="subsc">검사하기</span>
                                        </a>
                                    </li>
                                    <li className="bg2">
                                        <a href="/psychlgclCheck/depression">
                                            <img src="/images/therapy/therapy_depression.png" alt=""></img>
                                            <strong className="f18">우울 자가진단</strong>
                                            <span>(20문항)</span>
                                            <span className="subsc">검사하기</span>
                                        </a>
                                    </li>
                                    <li className="bg3">
                                        <a href="/psychlgclCheck/anxiety">
                                            <img src="/images/therapy/therapy_nervous.png" alt=""></img>
                                            <strong className="f18">불안 자가진단</strong>
                                            <span>(21문항)</span>
                                            <span className="subsc">검사하기</span>
                                        </a>
                                    </li>
                                    <li className="bg4">
                                        <a href="/psychlgclCheck/angry">
                                            <img src="/images/therapy/therapy_angry.png" alt=""></img>
                                            <strong className="f18">화병 성격척도</strong>
                                            <span>(15문항)</span>
                                            <span className="subsc">검사하기</span>
                                        </a>
                                    </li>
                                    <li className="bg5">
                                        <a href="/psychlgclCheck/traumatic">
                                            <img src="/images/therapy/therapy_traumatic.png" alt=""></img>
                                            <strong className="f18">외상 후 스트레스</strong>
                                            <span>(17문항)</span>
                                            <span className="subsc">검사하기</span>
                                        </a>
                                    </li>
                                    <li className="bg6">
                                        <a href="/psychlgclCheck/happy">
                                            <img src="/images/therapy/therapy_happy.png" alt=""></img>
                                            <strong className="f18">행복 자가진단</strong>
                                            <span>(4문항)</span>
                                            <span className="subsc">검사하기</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PsychlngclCheckMain;